import { useCallback } from "react";
import { Drawer as DrawerType } from "melco-shared-logic";
import { Drawer, FullWidthSpace } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useViewerLink } from "../../../../hooks/reporting/useViewerLink";
import { DisplayGenerateViewerLinkForm } from "./DisplayGenerateViewerLinkForm";
import { DisplayDetailViewerLinkForm } from "./DisplayDetailViewerLinkForm";

export type ViewerLinkSteps = "viewerLink" | "setPermissions" | "finish";

type ViewerLinkDrawerProps = {
  drawer: DrawerType;
  viewId: string | null | undefined;
};

export const ViewerLinkDrawer: React.FC<ViewerLinkDrawerProps> = ({
  drawer,
  viewId,
}) => {
  const { t } = useTranslation();
  const { data: viewerLinkDetail, refetch } = useViewerLink(viewId);
  const { closeDrawer, isDrawerOpen } = drawer;

  const closeAndReset = useCallback(() => {
    closeDrawer();
  }, [closeDrawer]);

  return (
    <Drawer
      title={t("reporting.machinestatus.view.viewerlink.drawer.title")}
      placement="right"
      width={700}
      closable={true}
      onClose={closeAndReset}
      open={isDrawerOpen}
    >
      <FullWidthSpace direction="vertical">
        {!viewerLinkDetail && (
          <>
            <DisplayGenerateViewerLinkForm
              callbackViewerLinkDetail={() => {
                refetch();
              }}
            />
          </>
        )}

        {viewerLinkDetail && (
          <>
            <DisplayDetailViewerLinkForm
              viewId={viewId ?? ""}
              viewerLinkDetail={viewerLinkDetail}
              closeAndReset={closeAndReset}
            />
          </>
        )}
      </FullWidthSpace>
    </Drawer>
  );
};
